// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>7</span>&nbsp;&nbsp;For the king puts his trust in the Lord;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;because of the loving-kindness of the Most High,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;he shall not be overthrown.<br> </p> </div></div>";
// Exports
module.exports = code;